import { useMutation } from 'react-query';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { updateProject } from 'src/services/napi/projects/updateProject';
import { UseMutateProjectInterface } from './interfaces/useMutateProject.interface';
import { useNotification } from '../../../providers/notificationsProvider';

const updateProjectMutations = async (data: Project) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject || !data._id) return;

  const { _id: projectId } = data;
  const updatedProject = await updateProject(projectId, data);

  return updatedProject;
};

export const useUpdateProject = ({ onError, onSuccess }: UseMutateProjectInterface) => {
  const { notify } = useNotification();

  return useMutation((data: Project) => updateProjectMutations(data), {
    onError: () => {
      notify({ message: 'something went wrong', severity: 'error' });
      if (onError) {
        onError();
      }
    },
    onSuccess: () => {
      notify({ message: 'Project was updated successfully', severity: 'success' });
      if (onSuccess) {
        onSuccess();
      }
    }
  });
};
